import { noop, useSettings } from '@capsicum/common';
import { useDAppsRiskWarningActionGuard, useRouter } from '@capsicum/common-web';
import { type NCWalletButtonsAction, useWalletNetworks } from '@capsicum/features/nc-wallet/shared';
import { useMemo } from 'react';

export const useNCWalletActionBarNavigation = () => {
	const { push } = useRouter();
	const { settings } = useSettings();
	const { isWalletNetworksLoading } = useWalletNetworks();
	const triggerDAppsRiskWarningGuardedAction = useDAppsRiskWarningActionGuard();

	const navToStake = () => triggerDAppsRiskWarningGuardedAction(() => window.open(settings.stakeLink, '_blank'));

	const navToHistory = () => push('/transaction-history');

	const navigationCallbacks: Record<NCWalletButtonsAction, () => void> = useMemo(
		() => ({
			buysell: noop, // TODO: replace
			history: isWalletNetworksLoading ? noop : navToHistory,
			receive: () => push('/nc-wallet/receive'),
			send: () => push('/nc-wallet/send'),
			stake: navToStake,
			topup: () => push('/nc-wallet/topup')
		}),
		[isWalletNetworksLoading, navToHistory, push, navToStake]
	);

	return {
		navigationCallbacks
	};
};
